import { Injectable } from '@angular/core';

@Injectable()
export class DecryptionService {

  constructor() { }

  async decryptAesGcm(encodedResult: string, secretKey: string): Promise<string> {
    const textDecoder = new (window as any).TextDecoder();
    const textEncoder = new (window as any).TextEncoder();
    const resultBytes = new Uint8Array(atob(encodedResult).split('').map(c => c.charCodeAt(0)));
    const nonce = resultBytes.slice(0, 12);
    const encryptedBytes = resultBytes.slice(12);
    const keyBuffer = textEncoder.encode(secretKey);
    const key = await crypto.subtle.importKey('raw', keyBuffer, { name: 'AES-GCM' }, false, ['decrypt']);
    const decrypted = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv: nonce },
      key,
      encryptedBytes
    );
    return textDecoder.decode(decrypted);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/decryption.service.ts